const baseUrl = 'https://akabab.github.io/superhero-api/api/all.json';

export default baseUrl;
